__turbopack_context__.v({
  "dropin": "Valpay-module__vKGfPG__dropin",
});
